import {css} from '../../theme/css'
import {theme} from '../../theme/theme'
import {Variant} from './types'

const root = css`
  // For correct alignment with the text.
  //vertical-align: middle;
  flex-shrink: 0;
`
const variant: Record<`variant_${Variant}`, string> = {
  variant_accent: css``,
  variant_default: css``,
  variant_important: css`
    // Cinnabar/Toxic
    background-color: #fc5230;
    box-shadow: 0 2px 5px rgba(212, 65, 46, 0.3);
    border-radius: 100px;
    padding: ${theme.spacing(0.25, 0.75)};
    vertical-align: bottom;

    // криво написан стиль в базовом компоненте
    .${root}& {
      // Theme/Default/Day/Background
      color: ${theme.go.schemes.colors.system.BgMain};
    }
  `,
  variant_invert: css`
    background-color: ${theme.go.schemes.colors.system.TextMain};
    border-radius: 50%;

    .${root}& {
      // Theme/Default/Day/Background
      color: ${theme.go.schemes.colors.system.BgMain};
    }
  `,
}
const base = {
  root,
}

export const classes = Object.assign(base, variant)
